import React from "react";

const WHATSAPP_URL = "https://wa.me/918796564619";

/**
 * Floating WhatsApp button - persistent across all pages.
 * Positioned bottom-right; on mobile pushed up to clear sticky CTA bar.
 */
export const WhatsAppButton = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Chat with Aurevia on WhatsApp"
      className="fixed right-5 md:right-8 bottom-20 md:bottom-8 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_40px_-8px_rgba(37,211,102,0.55)] ring-1 ring-white/10 transition-transform duration-300 hover:scale-105 hover:shadow-[0_14px_48px_-6px_rgba(37,211,102,0.7)]"
    >
      <svg
        viewBox="0 0 32 32"
        className="h-7 w-7"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M19.11 17.27c-.31-.16-1.82-.9-2.1-1-.28-.1-.49-.15-.7.15-.2.31-.8 1-.98 1.21-.18.21-.36.23-.67.08-.31-.16-1.3-.48-2.48-1.53-.92-.82-1.54-1.82-1.72-2.13-.18-.31-.02-.48.13-.63.14-.14.31-.36.46-.54.16-.18.21-.31.31-.52.1-.21.05-.39-.03-.54-.08-.15-.7-1.69-.96-2.32-.25-.6-.51-.52-.7-.53l-.6-.01c-.21 0-.54.08-.83.39-.28.31-1.08 1.06-1.08 2.59 0 1.53 1.11 3 1.27 3.21.16.21 2.18 3.33 5.28 4.67.74.32 1.31.51 1.76.65.74.24 1.41.2 1.94.12.59-.09 1.82-.74 2.08-1.45.26-.71.26-1.32.18-1.45-.08-.13-.28-.21-.59-.36zM16.03 5.33C10.13 5.33 5.33 10.13 5.33 16.03c0 2.08.6 4.02 1.63 5.66l-1.07 3.91 4.01-1.05a10.65 10.65 0 0 0 5.13 1.31h.01c5.9 0 10.7-4.8 10.7-10.7 0-2.86-1.11-5.55-3.13-7.57a10.61 10.61 0 0 0-7.58-3.16zM16.03 24.04c-1.62 0-3.21-.43-4.59-1.26l-.33-.2-3.39.89.9-3.3-.21-.34a8.77 8.77 0 0 1-1.36-4.7c0-4.85 3.94-8.79 8.79-8.79 2.35 0 4.55.91 6.21 2.58 1.66 1.66 2.58 3.86 2.58 6.21-.01 4.86-3.96 8.79-8.8 8.79z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
